import axios from 'axios';
import { generateCsrfToken } from './utils/generateCsrfToken';
import { getDebugParams } from './utils/getDebugParams';

export function setupAxiosInterceptors(target: 'app' | 'widget'): void {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    axios.defaults.withCredentials = true;

    axios.interceptors.request.use(
        async (config) => {
            if (config.method?.toLowerCase() !== 'get') {
                config.headers['X-Csrf-Token'] = await generateCsrfToken();
            }
            config.params = {
                ...getDebugParams(),
                ...config.params,
            };

            return config;
        },
        (error: Error): Promise<void> => Promise.reject(error),
    );

    axios.interceptors.response.use(
        (response) => {
            if (
                target === 'app' &&
                response.headers['Decline-Reason'] === 'by-geo' &&
                `${location.protocol}//${location.host}${location.pathname}` !==
                    `${process.env.REACT_APP_BASE_PATH}/error/451`
            ) {
                window.location.href = `${process.env.REACT_APP_BASE_PATH}/error/451`;
            }

            return response;
        },
        (error) => {
            if (
                target === 'app' &&
                error.response.status === 401 &&
                error.config.url !== '/user/actions' &&
                error.config.url !== '/user/profile'
            ) {
                window.location.href = `${process.env.REACT_APP_PASSPORT_URL}/auth?retpath=${window.location.href}`;
            }

            if (
                target === 'app' &&
                error.response.headers.get('Decline-Reason') === 'by-geo' &&
                `${location.protocol}//${location.host}${location.pathname}` !==
                    `${process.env.REACT_APP_BASE_PATH}/error/451`
            ) {
                window.location.href = `${process.env.REACT_APP_BASE_PATH}/error/451`;
            }

            return Promise.reject(error);
        },
    );
}
